import { useContext } from "react";
import { TourContext, TourContextType } from "./TourContext";

export const useTourContext = (): TourContextType => {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error("useTourContext must be used within a TourRefsProvider");
  }
  return context;
};
